export const machineRouteId = machine => String(machine?.routeId?._id || machine?.routeId || '');

export const catalogRouteOptions = machines => {
    const routes = new Map();
    machines.forEach(machine => {
        const id = machineRouteId(machine);
        if (id) routes.set(id, { value: id, label: machine.catalogRouteName || machine.routeId?.name || id });
    });
    return [...routes.values()].sort((a, b) => a.label.localeCompare(b.label));
};
